export default "__VITE_PUBLIC_ASSET__b3e16427__"